import { inject } from 'vue'
import { loc } from '@/__core__/localization/localization'
import { DAY_NAMES, MONTH_NAMES } from '@/__core__/utils/date'

/**
 * @param { String } startTime
 * @returns {{ isUpcoming: boolean, date: string, time: string }}
 */
export const adjustUpcomingEventTime = (startTime = '') => {
  const date = new Date(startTime)

  return {
    isUpcoming: date.getTime() > Date.now(),
    date: formatDate(date),
    time: getTime(date)
  }
}

/**
 * @param {{ isGameLive: boolean, matchIncident: string, matchStatus: string, matchResultsPerPeriod: Object, startTime: string }} initialData
 */
export const obtainMatchStatus = (initialData = null) => {
  if (initialData?.matchStatus || initialData?.matchIncident) {
    return initialData.matchStatus
  }

  return ''
}

export const initialDataAdapter = (adapteeId = '') =>
  ({
    fixtures: fixturesEventData => {
      const [home, away] = fixturesEventData.teams

      return {
        id: fixturesEventData.id,
        headerData: {
          home: {
            id: home.id,
            name: home.name,
            shortName: home.shortName,
            score: home.score,
            logo: home.logoUrl
          },
          away: {
            id: away.id,
            name: away.name,
            shortName: away.shortName,
            score: away.score,
            logo: away.logoUrl
          }
        },
        matchStatus: fixturesEventData.timeStatus || fixturesEventData.matchStatus,
        live: fixturesEventData.live,
        upcomingEventStartTime: adjustUpcomingEventTime(fixturesEventData.startTime)
      }
    }
  }[adapteeId])

//////////////////////////////////// ---- DATE UTILS ---- ////////////////////////////////////

/** @param {Date} date */
export const getTime = date => `${pad(date.getHours())}:${pad(date.getMinutes())}`

const pad = num => (num < 10 ? `0${num}` : num)

// MUST BE USED INSIDE VUE COMPONENT BECAUSE OF THE INJECT
export const formatDate = (date, langId = '', format = 'DD_short, DD_num MM_short') => {
  langId = langId || inject('langId', '')

  const day = loc(DAY_NAMES[date.getDay()], langId)
  const dateOfMonth = date.getDate()
  const month = loc(MONTH_NAMES[date.getMonth()], langId)
  const year = date.getFullYear()

  if (format === 'DD_short, DD_num MM_short') {
    return `${day}, ${dateOfMonth.toString().padStart(2, '0')} ${month}`
  } else if (format === 'DD_num MM_short') {
    return `${dateOfMonth.toString().padStart(2, '0')} ${month}`
  } else if (format === 'D_num M_short YYYY') {
    return `${dateOfMonth.toString()} ${month} ${year}`
  } else {
    throw new Error(`[formatDate]: Invalid format: ${format}`)
  }
}
